import axios from "axios";

class RestApiClient {
  constructor(config) {
    //config["timeout"] = 10000;
    this.client = axios.create(config);
  }

  request(options) {
    return this.client.request(options);
  }
}

const createRestApiClient = () => ({
  withConfig: config => new RestApiClient(config)
});

export default createRestApiClient;
